import React, { useMemo, useEffect } from 'react';
import t from '~t';
import { useDispatch, useSelector } from 'react-redux';
import {
  sharingLoad,
  sharingUpdateUser,
  sharingUnshare,
} from '~data/actions/collections';
import {
  makeCollection,
  makeSharingByRole,
  getSharingStatus,
  getSharingCount,
} from '~data/selectors/collections';

import { Confirm } from '~co/overlay/dialog';
import { Separator } from '~ui';
import View from './view';
import Invite from './invite';

export default function CollectionSharingCollaborators({ _id, ...etc }) {
  const dispatch = useDispatch();

  const getCollection = useMemo(makeCollection, []);
  const getSharingByRole = useMemo(makeSharingByRole, []);

  const collection = useSelector((state) => getCollection(state, _id));
  const users = useSelector((state) => getSharingByRole(state, _id));
  const count = useSelector((state) => getSharingCount(state, _id));
  const status = useSelector((state) => getSharingStatus(state, _id));

  useEffect(() => {
    dispatch(sharingLoad(_id));
  }, [_id, dispatch]);

  const handlers = {
    onUserUpdate: (userId, params) => {
      dispatch(sharingUpdateUser(_id, userId, params));
    },

    onUnshare: async (e) => {
      if (e && e.preventDefault) e.preventDefault();

      if (await Confirm(t.s('areYouSure'), { variant: 'warning' }))
        dispatch(sharingUnshare(_id));
    },
  };

  const viewProps = {
    _id,
    collection,
    users,
    count,
    status,
    ...etc,
  };

  return (
    <>
      <View {...viewProps} {...handlers} />
      <Separator />
      <Invite {...viewProps} />
    </>
  );
}
